export default __webpack_public_path__ + "static/media/men.9acb32df.jpg";